module.exports = __webpack_public_path__ + "static/service01-59bc7c3132335eec161b89035a8693cd.jpg";